<div class="stepper-body">
    <div class="body-title">
        <span>Any other sources of income you plan to use to qualify for this loan?</span>
    </div>
    <div class="body-description">
        <span>This could be income from a W-2, Self-Employment, Retirement, or Bank Statements.</span>
    </div>
    <div class="body-answers custom-answers">
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(InvestmentExtraIncomeOptions.Yes)
                        }" (click)="onAnswerSelected(InvestmentExtraIncomeOptions.Yes)">
                {{InvestmentExtraIncomeOptions.Yes}}
            </button>
        </div>
        <div class="custom-container">
            <button mat-stroked-button class="step-option" [ngClass]="{
                            'selected':isBtnSelected(InvestmentExtraIncomeOptions.No)
                        }" (click)="onAnswerSelected(InvestmentExtraIncomeOptions.No)">
                {{InvestmentExtraIncomeOptions.No}}
            </button>
        </div>
    </div>
</div>
<div class="stepper-footer">
    <mat-divider></mat-divider>
    <div class="step-controls">
        <button mat-stroked-button color="primary"
            (click)="onBack()" class="step-button secondary" [disabled]="false">
            Back
        </button>
        <button mat-flat-button color="primary" (click)="onNext()" class="step-button primary" [disabled]="isNextDisabled()">
            Next
        </button>
    </div>
</div>